export default __webpack_public_path__ + "static/media/logo-dark.bb237930.svg";